import React from "react";

export const SuccessStep = (props) => {
  return (
    <>
      <div className="add-recipient-header">
        <h4 className="add-recipient-title"><span className="yellow">{Drupal.t("Success!")}</span></h4>
      </div>
      <div className="add-recipient-body-content">
        <div className="add-recipient-description">
          {Drupal.t("You’ve added a new recipient.  When you create a new bank transfer, a list of stored contacts will appear to choose from.")}
        </div>
      </div>
    </>
  );
};
